import { render, staticRenderFns } from "./ShowCustomerInfo.vue?vue&type=template&id=bfe0d254&scoped=true&lang=pug"
import script from "./ShowCustomerInfo.vue?vue&type=script&lang=js"
export * from "./ShowCustomerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe0d254",
  null
  
)

export default component.exports